/* eslint-disable no-self-assign */
/* eslint-disable jsx-a11y/anchor-has-content */

import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import axios from 'axios';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import CircularProgress from '@mui/material/CircularProgress';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Select from '@mui/material/Select';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import ListSubheader from '@mui/material/ListSubheader';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Switch from '@mui/material/Switch';
import red from '@mui/material/colors/red';
import blue from '@mui/material/colors/blue';
import grey from '@mui/material/colors/grey';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload, faCalculator, faTimes, faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { v4 as uuidv4 } from 'uuid';
import { addClassNumber } from './utils/Dangerous.js';

function Product(props) {
    const {
        PRODUCT_TYPES,
        _key: key,
        cmOrInches, setCmOrInches,
        kgOrLbs, setKgOrLbs,
        width, setWidth,
        height, setHeight,
        length, setLength,
        weight, setWeight,
        volume, setVolume,
        type, setType,
        commodity, setCommodity,
        nonstackable, setNonStackable,
        dangerous, setDangerous,
        transportationMethod,
        temperature, setTemperature,
        chargeableWeight, setChargeableWeight,
        celsiusOrFahrenheit, setCelsiusOrFahrenheit,
        dangerousClass, setDangerousClass,
        dangerousUNCode, setDangerousUNCode,
        dangerousMSDS, setDangerousMSDS,
        quantity, setQuantity,
        errors,
        organization, accesstoken,
        hideUnitSelectors, hideShipmentToggles, hideInlineUnitToggles, hideAddPackageButton, hideDangerousDetails, hideRoundChargeableWeight,
        product, setProduct, allProducts,
    } = props;

    const [ uploading, setUploading ] = useState(false);
    const [ localHeight, setLocalHeight ] = useState(height);
    const [ localWidth, setLocalWidth ] = useState(width);
    const [ localLength, setLocalLength ] = useState(length);
    const [ localVolume, setLocalVolume ] = useState(volume);
    const [ localChargeableWeight, setLocalChargeableWeight ] = useState(chargeableWeight);
    const [ airType, setAirType ] = useState(transportationMethod === 'sea' ? null : getAirType({ width, height, length, volume, chargeableWeight }));

    const [ localDangerousClass, setLocalDangerousClass ] = useState(dangerousClass);
    const [ localDangerousUNCode, setLocalDangerousUNCode ] = useState(dangerousUNCode);
    const [ localDangerousMSDS, setLocalDangerousMSDS ] = useState(dangerousMSDS);
    const [ uploadError, setUploadError ] = useState(null);
    // An MSDS is a file somebody uploaded, and what is stored is the link to it. Details read out
    // of an email can leave something else there — "MSDS attached" is a sentence, not a link — and
    // that was still offered as a "View MSDS File" button. A browser reads a bare phrase as a
    // relative address, so opening it navigated to a route that does not exist and took the page
    // down. Anything that is not a link is not a file: the upload is offered instead, and what the
    // email actually said is shown next to it rather than quietly dropped.
    const msdsFileUrl = /^https?:\/\//i.test(String(localDangerousMSDS || '')) ? localDangerousMSDS : null;
    const msdsMention = !msdsFileUrl && localDangerousMSDS ? String(localDangerousMSDS) : null;

    function _setDangerousClass(dangerousClass) {
        setLocalDangerousClass(dangerousClass);
        if (dangerous) {
            setDangerousClass(dangerousClass);
        }
    }
    function _setDangerousUNCode(dangerousUNCode) {
        setLocalDangerousUNCode(dangerousUNCode);
        if (dangerous) {
            setDangerousUNCode(dangerousUNCode);
        }
    }
    function _setDangerousMSDS(dangerousMSDS) {
        setLocalDangerousMSDS(dangerousMSDS);
        if (dangerous) {
            setDangerousMSDS(dangerousMSDS);
        }
    }
    function _setDangerous(dangerous) {
        setDangerous(dangerous);
        if (dangerous) {
            setDangerousClass(localDangerousClass);
            setDangerousUNCode(localDangerousUNCode);
            setDangerousMSDS(localDangerousMSDS);
        } else {
            setDangerousClass(undefined);
            setDangerousUNCode(undefined);
            setDangerousMSDS(undefined);
        }
    }

    function _setHeight(height) {
        setLocalHeight(height);
        if (airType === 'dimensions' || transportationMethod === 'sea') {
            setHeight(height);
            setVolume(undefined);
        }
    }
    function _setWidth(width) {
        setLocalWidth(width);
        if (airType === 'dimensions' || transportationMethod === 'sea') {
            setWidth(width);
        }
    }  
    function _setLength(length) {
        setLocalLength(length);
        if (airType === 'dimensions' || transportationMethod === 'sea') {
            setLength(length);
        }
    }
    function _setVolume(volume) {
        setLocalVolume(volume);
        if (airType === 'volume' || transportationMethod === 'sea') {
            setVolume(volume);
        }
    }
    function _setChargeableWeight(chargeableWeight) {
        setLocalChargeableWeight(chargeableWeight);
        if (airType === 'chargeable-weight' || transportationMethod === 'sea') {
            setChargeableWeight(chargeableWeight);
        }
    }
    function _setAirType(airType) {
        setAirType(airType);
        if (airType === 'dimensions') {
            setHeight(localHeight || 0);
            setWidth(localWidth || 0);
            setLength(localLength || 0);
            setVolume(undefined);
            setChargeableWeight(undefined);
        } else if (airType === 'volume') {
            setHeight(undefined);
            setWidth(undefined);
            setLength(undefined);
            setVolume(localVolume || 0);
            setChargeableWeight(undefined);
        } else {
            setHeight(undefined);
            setWidth(undefined);
            setLength(undefined);
            setVolume(undefined);
            setChargeableWeight(localChargeableWeight || 0);
        }
    }

    const ask = transportationMethod
        ? ((PRODUCT_TYPES[transportationMethod] || []).find(p => p.name === type) || {}).ask || [] 
        : (_.flatten(_.keys(PRODUCT_TYPES).map(tm => PRODUCT_TYPES[tm])).find(p => p.name === type) || {}).ask || [];

    async function onSubmit(e) {
        e.preventDefault();
        const formData = new FormData();
        const file = document.getElementById(`${key}.fileupload`).files[0];
        if (!file) return;
        formData.append('file', file, file.name);
        setUploading(true);
        setUploadError(null);
        try {
            const { data } = await axios({
                url: `/api/opportunities/upload_file?accesstoken=${accesstoken}&organizationId=${organization.id}`,
                method: 'post',
                data: formData,
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            // Without a link there is no file to come back to, and storing nothing while saying
            // nothing is how an upload came to be reported as done and then not be there.
            if (!data?.location) throw new Error('The upload did not come back with a link to the file.');
            _setDangerousMSDS(data.location);
        } catch (err) {
            // This used to throw out of an unawaited handler: the spinner ran forever, no file was
            // stored, and the screen said nothing had gone wrong.
            setUploadError(err?.response?.data?.detail || err?.message || 'The file could not be uploaded.');
        } finally {
            setUploading(false);
        }
    }

    // LCL calculation helpers
    function updateCalculation(index, field, value) {
        if (!product || !setProduct) return;
        setProduct({
            ...product,
            calculations: (product.calculations || []).map((c, i) => i === index ? { ...c, [field]: value } : c)
        });
    }
    function addCalculation() {
        if (!product || !setProduct) return;
        setProduct({
            ...product,
            calculations: [...(product.calculations || []), { id: uuidv4(), method: 'volume', quantity: 1, commodity: 'General' }]
        });
    }
    function addAirCalculation() {
        if (!product || !setProduct) return;
        setProduct({
            ...product,
            calculations: [...(product.calculations || []), { id: uuidv4(), method: 'dimensions', quantity: 1, commodity: 'General' }]
        });
    }
    function deleteCalculation(index) {
        if (!product || !setProduct) return;
        setProduct({
            ...product,
            calculations: (product.calculations || []).filter((_, i) => i !== index)
        });
    }
    function setLCLField(field, value) {
        if (!product || !setProduct) return;
        setProduct({ ...product, [field]: value });
    }
    function setAirFreightField(field, value) {
        if (!product || !setProduct) return;
        setProduct({ ...product, [field]: value });
    }

    return (
        <div style={{ width: '100%' }}>
            <Grid container spacing={0}>
                <Grid item xs={12} >
                    <div style={{ padding: (ask.includes('lcl-calculations') || ask.includes('air-calculations')) ? '0px' : '12px', width: '100%' }}>
                        <Grid container spacing={0}>
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    {transportationMethod === 'sea' && type !== 'LCL' && (
                                        <Box sx={{ display: 'flex', marginBottom: '6px', flexDirection: 'column', width: 'calc(100% - 16px)' }}>
                                            <FormControl sx={{ m: 1, width: '100%' }}>
                                                <InputLabel id={`label-size-${key}`}>Container Type</InputLabel>
                                                <Select
                                                    label='Container Type'
                                                    id={`select-type-${key}`}
                                                    value={type || "20' Dry"}
                                                    onChange={(event: SelectChangeEvent) => setType(event.target.value) }
                                                >
                                                    {_.map(PRODUCT_TYPES[transportationMethod], (type) => (
                                                        type.name.startsWith('By') || type.name === 'LCL' ? null : <MenuItem key={`container-type-${type.name}`} value={type.name}>{type.name}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    )}

                                    {transportationMethod === 'land' && (
                                        <FormControl sx={{ m: 1, minWidth: 120, mb: 2 }} error={errors.includes('type')}>
                                            <InputLabel id={`label-size-${key}`}>Type</InputLabel>
                                            <Select
                                                label='Type'
                                                id={`select-type-${key}`}
                                                value={type}
                                                onChange={(event: SelectChangeEvent) => setType(event.target.value) }
                                            >
                                                {['Containers', 'LCL', 'Air', 'Trucks'].flatMap(group => {
                                                    const items = (PRODUCT_TYPES[transportationMethod] || []).filter(t => t.group === group);
                                                    if (!items.length) return [];
                                                    return [
                                                        <ListSubheader key={`group-${group}`}>{group}</ListSubheader>,
                                                        ...items.map(t => (
                                                            <MenuItem key={`container-type-${t.name}`} value={t.name}>{t.name}</MenuItem>
                                                        )),
                                                    ];
                                                })}
                                                {/* Fallback so a legacy/ungrouped selected type (e.g. an existing "By Dimensions"
                                                    land product) still renders in the dropdown instead of showing blank. */}
                                                {type && !(PRODUCT_TYPES[transportationMethod] || []).some(t => t.group && t.name === type) && (
                                                    <MenuItem key={`container-type-${type}`} value={type}>{type}</MenuItem>
                                                )}
                                            </Select>
                                        </FormControl>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                        {ask.includes('lcl-calculations') && product && (
                            <Box sx={{ width: '100%', padding: 0 }}>
                                {/* LCL-level density ratio (unit selectors are in the shared header) */}
                                {!hideUnitSelectors && (
                                    <Grid container spacing={2} sx={{ mb: 2 }}>
                                        <Grid item xs={6}>
                                            <FormControl fullWidth size='small'>
                                                <InputLabel>Weight Unit</InputLabel>
                                                <Select
                                                    label='Weight Unit'
                                                    value={product.kgOrLbs || 'kg'}
                                                    onChange={(e) => setLCLField('kgOrLbs', e.target.value)}
                                                >
                                                    <MenuItem value='kg'>kg</MenuItem>
                                                    <MenuItem value='lbs'>lbs</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <FormControl fullWidth size='small'>
                                                <InputLabel>Dimension Unit</InputLabel>
                                                <Select
                                                    label='Dimension Unit'
                                                    value={product.cmOrInches || 'cm'}
                                                    onChange={(e) => setLCLField('cmOrInches', e.target.value)}
                                                >
                                                    <MenuItem value='cm'>cm</MenuItem>
                                                    <MenuItem value='in.'>inches</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                )}

                                {/* Calculations list */}
                                {(product.calculations || []).map((calc, calcIndex) => {
                                    const isDim = calc.method === 'dimensions';
                                    const dimUnit = product.cmOrInches || 'cm';
                                    const wUnit = product.kgOrLbs || 'kg';
                                    const unitAdornment = (u) => ({
                                        endAdornment: <InputAdornment position='end'><span style={{ color: blue[500], fontWeight: 600 }}>{u}</span></InputAdornment>
                                    });
                                    const onMethodChange = (newMethod) => {
                                        const updates = { method: newMethod };
                                        if (newMethod === 'volume') {
                                            updates.length = undefined; updates.width = undefined; updates.height = undefined;
                                        } else {
                                            updates.volume = undefined;
                                        }
                                        if (!product || !setProduct) return;
                                        setProduct({
                                            ...product,
                                            calculations: (product.calculations || []).map((c, i) => i === calcIndex ? { ...c, ...updates } : c)
                                        });
                                    };
                                    return (
                                        <Box key={calc.id || calcIndex} sx={{ border: '1px solid #e2e8f0', borderRadius: '8px', padding: '12px 16px', marginBottom: '10px', backgroundColor: '#f8fafc', position: 'relative' }}>
                                            {/* Header: Package #N + Method selector + X */}
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1.5 }}>
                                                <Typography sx={{ fontWeight: 700, fontSize: '14px', whiteSpace: 'nowrap' }}>
                                                    Package #{calcIndex + 1}
                                                </Typography>
                                                <FormControl size='small' sx={{ minWidth: 180 }}>
                                                    <Select value={calc.method || 'volume'} onChange={(e) => onMethodChange(e.target.value)}>
                                                        <MenuItem value='dimensions'>By Dimensions</MenuItem>
                                                        <MenuItem value='volume'>By Volume</MenuItem>
                                                    </Select>
                                                </FormControl>
                                                <IconButton size='small' onClick={() => deleteCalculation(calcIndex)} sx={{ ml: 'auto', color: '#94a3b8' }}>
                                                    <FontAwesomeIcon icon={faTimes} style={{ fontSize: '14px' }} />
                                                </IconButton>
                                            </Box>
                                            {/* Inline fields row */}
                                            <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                                                {isDim ? (
                                                    <>
                                                        <TextField size='small' label='Length' value={calc.length || ''} onChange={(e) => updateCalculation(calcIndex, 'length', e.target.value)} error={errors.includes(`calc-${calcIndex}-length`)} InputProps={unitAdornment(dimUnit)} sx={{ flex: 1, minWidth: 110 }} />
                                                        <TextField size='small' label='Width' value={calc.width || ''} onChange={(e) => updateCalculation(calcIndex, 'width', e.target.value)} error={errors.includes(`calc-${calcIndex}-width`)} InputProps={unitAdornment(dimUnit)} sx={{ flex: 1, minWidth: 110 }} />
                                                        <TextField size='small' label='Height' value={calc.height || ''} onChange={(e) => updateCalculation(calcIndex, 'height', e.target.value)} error={errors.includes(`calc-${calcIndex}-height`)} InputProps={unitAdornment(dimUnit)} sx={{ flex: 1, minWidth: 110 }} />
                                                    </>
                                                ) : (
                                                    <TextField size='small' label='Volume' value={calc.volume || ''} onChange={(e) => updateCalculation(calcIndex, 'volume', e.target.value)} error={errors.includes(`calc-${calcIndex}-volume`)} InputProps={unitAdornment('cbm')} sx={{ flex: 1, minWidth: 110 }} />
                                                )}
                                                <TextField size='small' label='Weight' value={calc.weight || ''} onChange={(e) => updateCalculation(calcIndex, 'weight', e.target.value)} error={errors.includes(`calc-${calcIndex}-weight`)} InputProps={unitAdornment(wUnit)} sx={{ flex: 1, minWidth: 110 }} />
                                                <TextField size='small' label='Qty' value={calc.quantity || ''} onChange={(e) => updateCalculation(calcIndex, 'quantity', e.target.value)} error={errors.includes(`calc-${calcIndex}-quantity`)} sx={{ flex: '0 0 80px' }} />
                                                <TextField size='small' label='Commodity' value={calc.commodity || ''} onChange={(e) => updateCalculation(calcIndex, 'commodity', e.target.value)} sx={{ flex: 1.2, minWidth: 140 }} />
                                            </Box>
                                        </Box>
                                    );
                                })}

                                {!hideAddPackageButton && (
                                    <Button
                                        variant='text'
                                        color='primary'
                                        fullWidth
                                        sx={{ marginTop: '6px' }}
                                        onClick={addCalculation}
                                    >
                                        + Add Package
                                    </Button>
                                )}
                            </Box>
                        )}
                        {ask.includes('air-calculations') && product && (
                            <Box sx={{ width: '100%', padding: 0 }}>
                                {/* Air freight product-level fields (unit selectors are in the shared header when hidden) */}
                                <Grid container spacing={2} sx={{ mb: 2 }}>
                                    {!hideUnitSelectors && (
                                        <>
                                            <Grid item xs={4}>
                                                <FormControl fullWidth size='small'>
                                                    <InputLabel>Weight Unit</InputLabel>
                                                    <Select
                                                        label='Weight Unit'
                                                        value={product.kgOrLbs || 'kg'}
                                                        onChange={(e) => setAirFreightField('kgOrLbs', e.target.value)}
                                                    >
                                                        <MenuItem value='kg'>kg</MenuItem>
                                                        <MenuItem value='lbs'>lbs</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <FormControl fullWidth size='small'>
                                                    <InputLabel>Dimension Unit</InputLabel>
                                                    <Select
                                                        label='Dimension Unit'
                                                        value={product.cmOrInches || 'cm'}
                                                        onChange={(e) => setAirFreightField('cmOrInches', e.target.value)}
                                                    >
                                                        <MenuItem value='cm'>cm</MenuItem>
                                                        <MenuItem value='in.'>inches</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        </>
                                    )}
                                    {/* Rounding is not a unit, and it has nowhere else to live unless the
                                        shared air bar is drawing one — on a land quote carrying air cargo
                                        that bar is absent, and hiding this with the unit selectors left the
                                        toggle off the screen entirely. */}
                                    {!hideRoundChargeableWeight && (
                                        <Grid item xs={4} sx={{ display: 'flex', alignItems: 'center' }}>
                                            <FormControlLabel
                                                control={<Switch checked={product.roundChargeableWeight !== false} onChange={(e) => setAirFreightField('roundChargeableWeight', e.target.checked)} />}
                                                label='Round Chargeable Weight'
                                            />
                                        </Grid>
                                    )}
                                </Grid>

                                {/* Air freight calculations list */}
                                {(product.calculations || []).map((calc, calcIndex) => {
                                    const method = calc.method || 'dimensions';
                                    const dimUnit = product.cmOrInches || 'cm';
                                    const wUnit = product.kgOrLbs || 'kg';
                                    const unitAdornment = (u) => ({
                                        endAdornment: <InputAdornment position='end'><span style={{ color: blue[500], fontWeight: 600 }}>{u}</span></InputAdornment>
                                    });
                                    const onMethodChange = (newMethod) => {
                                        const updates = { method: newMethod };
                                        if (newMethod === 'dimensions') {
                                            updates.volume = undefined; updates.chargeableWeight = undefined;
                                        } else if (newMethod === 'volume') {
                                            updates.length = undefined; updates.width = undefined; updates.height = undefined; updates.chargeableWeight = undefined;
                                        } else {
                                            updates.length = undefined; updates.width = undefined; updates.height = undefined; updates.volume = undefined;
                                        }
                                        if (!product || !setProduct) return;
                                        setProduct({
                                            ...product,
                                            calculations: (product.calculations || []).map((c, i) => i === calcIndex ? { ...c, ...updates } : c)
                                        });
                                    };
                                    return (
                                        <Box key={calc.id || calcIndex} sx={{ border: '1px solid #e2e8f0', borderRadius: '8px', padding: '12px 16px', marginBottom: '10px', backgroundColor: '#f8fafc', position: 'relative' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1.5 }}>
                                                <Typography sx={{ fontWeight: 700, fontSize: '14px', whiteSpace: 'nowrap' }}>
                                                    Package #{calcIndex + 1}
                                                </Typography>
                                                <FormControl size='small' sx={{ minWidth: 200 }}>
                                                    <Select value={method} onChange={(e) => onMethodChange(e.target.value)}>
                                                        <MenuItem value='dimensions'>By Dimensions</MenuItem>
                                                        <MenuItem value='volume'>By Volume</MenuItem>
                                                        <MenuItem value='chargeable-weight'>By Chargeable Weight</MenuItem>
                                                    </Select>
                                                </FormControl>
                                                <IconButton size='small' onClick={() => deleteCalculation(calcIndex)} sx={{ ml: 'auto', color: '#94a3b8' }}>
                                                    <FontAwesomeIcon icon={faTimes} style={{ fontSize: '14px' }} />
                                                </IconButton>
                                            </Box>
                                            <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                                                {method === 'dimensions' && (
                                                    <>
                                                        <TextField size='small' label='Length' value={calc.length || ''} onChange={(e) => updateCalculation(calcIndex, 'length', e.target.value)} error={errors.includes(`calc-${calcIndex}-length`)} InputProps={unitAdornment(dimUnit)} sx={{ flex: 1, minWidth: 110 }} />
                                                        <TextField size='small' label='Width' value={calc.width || ''} onChange={(e) => updateCalculation(calcIndex, 'width', e.target.value)} error={errors.includes(`calc-${calcIndex}-width`)} InputProps={unitAdornment(dimUnit)} sx={{ flex: 1, minWidth: 110 }} />
                                                        <TextField size='small' label='Height' value={calc.height || ''} onChange={(e) => updateCalculation(calcIndex, 'height', e.target.value)} error={errors.includes(`calc-${calcIndex}-height`)} InputProps={unitAdornment(dimUnit)} sx={{ flex: 1, minWidth: 110 }} />
                                                    </>
                                                )}
                                                {method === 'volume' && (
                                                    <TextField size='small' label='Volume' value={calc.volume || ''} onChange={(e) => updateCalculation(calcIndex, 'volume', e.target.value)} error={errors.includes(`calc-${calcIndex}-volume`)} InputProps={unitAdornment('cbm')} sx={{ flex: 1, minWidth: 110 }} />
                                                )}
                                                {method === 'chargeable-weight' && (
                                                    <TextField size='small' label='Chargeable Weight' value={calc.chargeableWeight || ''} onChange={(e) => updateCalculation(calcIndex, 'chargeableWeight', e.target.value)} error={errors.includes(`calc-${calcIndex}-chargeableWeight`) || errors.includes(`calc-${calcIndex}-chargeable-weight-gross-weight`)} InputProps={unitAdornment(wUnit)} sx={{ flex: 1, minWidth: 110 }} />
                                                )}
                                                <TextField size='small' label='Weight' value={calc.weight || ''} onChange={(e) => updateCalculation(calcIndex, 'weight', e.target.value)} error={errors.includes(`calc-${calcIndex}-weight`) || errors.includes(`calc-${calcIndex}-chargeable-weight-gross-weight`)} InputProps={unitAdornment(wUnit)} sx={{ flex: 1, minWidth: 110 }} />
                                                <TextField size='small' label='Qty' value={calc.quantity || ''} onChange={(e) => updateCalculation(calcIndex, 'quantity', e.target.value)} error={errors.includes(`calc-${calcIndex}-quantity`)} sx={{ flex: '0 0 80px' }} />
                                                <TextField size='small' label='Commodity' value={calc.commodity || ''} onChange={(e) => updateCalculation(calcIndex, 'commodity', e.target.value)} sx={{ flex: 1.2, minWidth: 140 }} />
                                            </Box>
                                            {errors.includes(`calc-${calcIndex}-chargeable-weight-gross-weight`) && (
                                                <Typography variant='caption' color='error' sx={{ textAlign: 'start', marginTop: '6px' }} component={'div'}>
                                                    Chargeable weight must be equal or greater than gross weight
                                                </Typography>
                                            )}
                                        </Box>
                                    );
                                })}

                                {!hideAddPackageButton && (
                                    <Button
                                        variant='text'
                                        color='primary'
                                        fullWidth
                                        sx={{ marginTop: '6px' }}
                                        onClick={addAirCalculation}
                                    >
                                        + Add Package
                                    </Button>
                                )}
                            </Box>
                        )}
                        {ask.includes('chargeable-weight') && (
                            <Grid container spacing={0} sx={{ paddingLeft: '8px', paddingRight: '8px', paddingBottom: '18px' }}>
                                <Grid item xs={12} sx={{ mb: 2 }}>
                                    <RadioGroup
                                        row
                                        value={airType}
                                        onChange={(e) => _setAirType(e.target.value)}
                                    >
                                        <FormControlLabel value='dimensions' control={<Radio />} label='By Dimensions' />
                                        <FormControlLabel value='volume' control={<Radio />} label='By Volume' />
                                        <FormControlLabel value='chargeable-weight' control={<Radio />} label='By Chargeable Weight' />
                                    </RadioGroup>
                                </Grid>
                                {airType === 'chargeable-weight' && (
                                    <Grid item xs={12} sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
                                        <FormControl sx={{ flex : 1 }}>
                                            <TextField
                                                fullWidth
                                                error={errors.includes('chargeableWeight') || errors.includes('air-freight-chargeable-weight-gross-weight')}
                                                variant='outlined'
                                                label='Chargeable Weight'
                                                id='chargeableWeight'
                                                value={localChargeableWeight}
                                                onChange={(event) => { _setChargeableWeight(event.target.value) }}
                                            />
                                        </FormControl>
                                        <Box sx={{ flex : 1, textAlign: 'center' }}>
                                            and
                                        </Box>
                                        <FormControl sx={{ flex: 1 }}>
                                            <TextField
                                                error={errors.includes('weight') || errors.includes('air-freight-chargeable-weight-gross-weight')}
                                                variant='outlined'
                                                label='Weight'
                                                id='weight'
                                                value={weight}
                                                onChange={(event) => { setWeight(event.target.value) }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position='end'>
                                                            <span
                                                                style={hideInlineUnitToggles ? {} : { cursor: 'pointer', color: blue[500] }}
                                                                onClick={hideInlineUnitToggles ? undefined : () => setKgOrLbs(kgOrLbs === 'kg' ? 'lbs' : 'kg')}
                                                            >
                                                                {kgOrLbs}
                                                            </span>
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>
                                )}
                                <Grid item xs={8} style={{ textAlign: 'center' }}>
                                    {errors.includes('chargeableWeight') && (
                                        <Typography variant='caption' color='error' sx={{ textAlign: 'start' }} component={'div'}>
                                            Please enter a <b>numeric</b> value.
                                        </Typography>
                                    )}
                                    {errors.includes('air-freight-chargeable-weight-gross-weight') && (
                                        <Typography variant='caption' color='error' sx={{ textAlign: 'start' }} component={'div'}>
                                            Chargeable weight must be equal or greater than gross weight
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                        )}
                        {((ask.includes('dimensions') && ask.includes('weight')) || (ask.includes('chargeable-weight') && airType === 'dimensions')) && (
                            <Grid container spacing={0} sx={{ paddingLeft: '8px', paddingRight: '8px', paddingBottom: '18px' }}>
                                <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                                    <FormControl sx={{ flex: 1 }}>
                                        <TextField 
                                            error={errors.includes('length')}
                                            variant='outlined'
                                            label='Length'
                                            id='length'
                                            value={localLength}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => { _setLength(event.target.value) }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position='end'>
                                                        <span
                                                            style={hideInlineUnitToggles ? {} : { cursor: 'pointer', color: blue[500] }}
                                                            onClick={hideInlineUnitToggles ? undefined : () => setCmOrInches(cmOrInches === 'cm' ? 'in.' : 'cm')}
                                                        >
                                                            {cmOrInches}
                                                        </span>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </FormControl>
                                    <div style={{ flex: 0, padding: '0px 12px' }}>
                                        X
                                    </div>
                                    <FormControl sx={{ flex: 1 }}>
                                        <TextField
                                            error={errors.includes('width')}
                                            variant='outlined'
                                            label='Width'
                                            id='width'
                                            value={localWidth}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => { _setWidth(event.target.value) }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position='end'>
                                                        <span
                                                            style={hideInlineUnitToggles ? {} : { cursor: 'pointer', color: blue[500] }}
                                                            onClick={hideInlineUnitToggles ? undefined : () => setCmOrInches(cmOrInches === 'cm' ? 'in.' : 'cm')}
                                                        >
                                                            {cmOrInches}
                                                        </span>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </FormControl>
                                    <div style={{ flex: 0, padding: '0px 12px' }}>
                                        X
                                    </div>
                                    <FormControl sx={{ flex: 1 }}>
                                        <TextField 
                                            error={errors.includes('height')}
                                            variant='outlined'
                                            label='Height'
                                            id='height'
                                            value={localHeight}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => { _setHeight(event.target.value) }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position='end'>
                                                        <span
                                                            style={hideInlineUnitToggles ? {} : { cursor: 'pointer', color: blue[500] }}
                                                            onClick={hideInlineUnitToggles ? undefined : () => setCmOrInches(cmOrInches === 'cm' ? 'in.' : 'cm')}
                                                        >
                                                            {cmOrInches}
                                                        </span>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </FormControl>
                                    <div style={{ flex: 0, padding: '0px 48px' }}>
                                        and
                                    </div>
                                    <FormControl sx={{ flex: 1 }}>
                                        <TextField 
                                            error={errors.includes('weight')}
                                            variant='outlined'
                                            label='Weight'
                                            id='weight'
                                            value={weight}
                                            onChange={(event) => { setWeight(event.target.value) }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position='end'>
                                                        <span
                                                            style={hideInlineUnitToggles ? {} : { cursor: 'pointer', color: blue[500] }}
                                                            onClick={hideInlineUnitToggles ? undefined : () => setKgOrLbs(kgOrLbs === 'kg' ? 'lbs' : 'kg')}
                                                        >
                                                            {kgOrLbs}
                                                        </span>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                {(errors.includes('height') || errors.includes('width') || errors.includes('length') || errors.includes('weight')) && (
                                    <Grid item xs={8}>
                                        <Typography variant='caption' color='error' sx={{ textAlign: 'start' }} component={'div'}>
                                            Please enter <b>numeric</b> values only for length, width, height, and weight.
                                        </Typography>
                                    </Grid>
                                )}
                            </Grid>
                        )}
                        {ask.includes('height') && (
                            <Grid container spacing={0} sx={{ paddingLeft: '8px', paddingRight: '8px', paddingBottom: '18px' }}>
                                <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <FormControl sx={{ flex: 1 }}>
                                        <TextField 
                                            error={errors.includes('height')}
                                            variant='outlined'
                                            label='Height'
                                            id='height'
                                            value={localHeight}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => { _setHeight(event.target.value) }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position='end'>
                                                        <span
                                                            style={hideInlineUnitToggles ? {} : { cursor: 'pointer', color: blue[500] }}
                                                            onClick={hideInlineUnitToggles ? undefined : () => setCmOrInches(cmOrInches === 'cm' ? 'in.' : 'cm')}
                                                        >
                                                            {cmOrInches}
                                                        </span>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={8} style={{ textAlign: 'center' }}>
                                    {errors.includes('height') && (
                                        <Typography variant='caption' color='error' sx={{ textAlign: 'start' }} component={'div'}>
                                            Please enter a <b>numeric</b> height.
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                        )}
                        {((ask.includes('weight-or-measurement') || (ask.includes('chargeable-weight') && airType === 'volume'))) && (
                            <Grid container spacing={0} sx={{ paddingLeft: '8px', paddingRight: '8px', paddingBottom: '18px' }}>
                                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                                    <FormControl sx={{ flex: 1 }}>
                                        <TextField 
                                            error={errors.includes('volume')}
                                            variant='outlined'
                                            label='Volume'
                                            id='volume'
                                            value={localVolume}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => { _setVolume(event.target.value) }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position='end'>
                                                        cbm
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </FormControl>
                                    <div style={{ flex: 1 }}>
                                        and
                                    </div>
                                    <FormControl sx={{ flex: 1 }}>
                                        <TextField 
                                            error={errors.includes('weight')}
                                            variant='outlined'
                                            label='Weight'
                                            id='weight'
                                            value={weight}
                                            onChange={(event) => { setWeight(event.target.value) }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position='end'>
                                                        {kgOrLbs}
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    {(errors.includes('weight') || errors.includes('volume')) && (
                                        <Typography variant='caption' color='error' sx={{ textAlign: 'start' }} component={'div'}>
                                            Please enter a <b>numeric</b> value for weight and volume.
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                        )}
                        {((ask.includes('weight')) && (!ask.includes('dimensions'))) && (
                            <Grid container spacing={0} sx={{ paddingLeft: '8px', paddingRight: '8px', paddingBottom: '18px' }}>
                                <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <FormControl sx={{ flex: 1 }}>
                                        <TextField 
                                            error={errors.includes('weight')}
                                            variant='outlined'
                                            label='Weight'
                                            id='weight'
                                            value={weight}
                                            onChange={(event) => { setWeight(event.target.value) }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position='end'>
                                                        <span
                                                            style={hideInlineUnitToggles ? {} : { cursor: 'pointer', color: blue[500] }}
                                                            onClick={hideInlineUnitToggles ? undefined : () => setKgOrLbs(kgOrLbs === 'kg' ? 'lbs' : 'kg')}
                                                        >
                                                            {kgOrLbs}
                                                        </span>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                                    {errors.includes('weight') && (
                                        <Typography variant='caption' color='error' sx={{ textAlign: 'start' }} component={'div'}>
                                            Please enter a <b>numeric</b> weight.
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                        )}
                        {ask.includes('temperature') && (
                            <Grid container spacing={0} sx={{ paddingLeft: '8px', paddingRight: '8px', paddingBottom: '18px' }}>
                                <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <FormControl sx={{ flex: 1 }}>
                                        <TextField 
                                            error={errors.includes('temperature')}
                                            variant='outlined'
                                            label={'Temperature'}
                                            id='temperature'
                                            value={temperature}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => { setTemperature(event.target.value) }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position='end'>
                                                        <span
                                                            style={{ cursor: 'pointer', color: blue[500] }}
                                                            onClick={() => setCelsiusOrFahrenheit(celsiusOrFahrenheit === 'c' ? 'f' : 'c')}
                                                        >
                                                            {celsiusOrFahrenheit}
                                                        </span>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        )}
                        {ask.includes('quantity') && (
                            <Grid container spacing={0} sx={{ paddingLeft: '8px', paddingRight: '8px', paddingBottom: '18px' }}>
                                <Grid item xs={12} style={{ textAlign: 'center' }}>
                                    <TextField 
                                        fullWidth
                                        error={errors.includes('quantity')}
                                        variant='outlined'
                                        label={'Quantity'}
                                        id='quantity'
                                        value={quantity}
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => { setQuantity(event.target.value) }}
                                    />
                                </Grid>
                                <Grid item xs={12} style={{ textAlign: 'center' }}>
                                    {errors.includes('quantity') && (
                                        <Typography variant='caption' color='error' sx={{ textAlign: 'start' }} component={'div'}>
                                            Quantity should include <b>digits</b> only.
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                        )}
                        {ask.includes('commodity') && (
                            <Grid container spacing={0} sx={{ paddingLeft: '8px', paddingRight: '8px', paddingBottom: '18px' }}>
                                <Grid item xs={12} style={{ textAlign: 'center' }}>
                                    <TextField 
                                        fullWidth
                                        variant='outlined'
                                        label={'Type of Commodity'}
                                        placeholder='General commodity'
                                        id='product-comments'
                                        value={commodity}
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => { setCommodity(event.target.value) }}
                                    />
                                </Grid>
                            </Grid>
                        )}
                        {ask.includes('non-stackable') && !hideShipmentToggles && (
                            <Grid container spacing={0} sx={{ paddingLeft: '8px', paddingRight: '8px', paddingBottom: '18px' }}>
                                <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <FormControlLabel control={<Switch checked={!nonstackable} onChange={() => setNonStackable(!nonstackable)} />} label='Stackable' />
                                </Grid>
                            </Grid>
                        )}
                        {ask.includes('dangerous') && !hideShipmentToggles && (
                            <Grid container spacing={0} sx={{ paddingLeft: '8px', paddingRight: '8px', paddingBottom: '18px' }}>
                                <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <FormControlLabel control={<Switch checked={dangerous} onChange={() => _setDangerous(!dangerous)} />} label='Dangerous' />
                                </Grid>
                            </Grid>
                        )}
                        {dangerous && !hideDangerousDetails && (
                            <Grid container spacing={0} sx={{ paddingLeft: '8px', paddingRight: '8px', paddingBottom: '18px' }}>
                                <Grid item xs={12}>
                                    {!msdsFileUrl && (
                                        <form
                                            style={{margin: '0px'}}
                                            id={`${key}.fileuploadform`}
                                            encType='multipart/form-data'
                                        >
                                            <input
                                                id={`${key}.fileupload`}
                                                style={{ display: 'none'}}
                                                type='file'
                                                onChange={onSubmit}
                                                name='file'/>
                                        </form>
                                    )}
                                    {msdsFileUrl && (
                                        <div style={{ position: 'relative' }}>
                                            <Button
                                                component='a'
                                                href={msdsFileUrl}
                                                target='_blank'
                                                rel='noopener noreferrer'
                                                variant='contained'
                                                color={'primary'}
                                            >
                                                View MSDS File
                                            </Button>
                                            <Button
                                                variant='text'
                                                color={'error'}
                                                sx={{ textTransform: 'none' }}
                                                onClick={() => _setDangerousMSDS(null)}
                                                size='small'
                                            >
                                                (remove)
                                            </Button>

                                        </div>
                                    )}
                                    {!msdsFileUrl && !uploading && (
                                        <Button
                                            variant='contained'
                                            onClick={() => document.getElementById(`${key}.fileupload`).click()}
                                        >
                                            <FontAwesomeIcon icon={faUpload} />&nbsp;
                                            Upload MSDS File
                                        </Button>
                                    )}
                                    {uploadError && !uploading && (
                                        <Typography variant='caption' sx={{ display: 'block', marginTop: '6px', color: red[500] }}>
                                            {uploadError} Please try again.
                                        </Typography>
                                    )}
                                    {msdsMention && !uploading && (
                                        <Typography variant='caption' sx={{ display: 'block', marginTop: '6px', color: grey[600] }}>
                                            The shipment details mention an MSDS (&ldquo;{msdsMention}&rdquo;) but no file came with them. Upload it here.
                                        </Typography>
                                    )}
                                    {!msdsFileUrl && uploading && (
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <div>
                                                Uploading MSDS File
                                            </div>
                                            <div style={{ marginLeft: '12px' }}>
                                                <CircularProgress size={12} />
                                            </div>
                                        </Box>
                                    )}
                                    {errors.includes('dangerousMSDS') && (
                                        <Typography sx={{ color: red[500] }} variant='caption'>
                                            Please upload file
                                        </Typography>
                                    )}
                                    <FormControl fullWidth error={errors.includes('dangerousClass')} sx={{ marginTop: '24px' }}>
                                        <InputLabel id={`dangerous-class-${key}`}>Class</InputLabel>
                                        <Select
                                            label='Class'
                                            id={`dangerous-class-${key}`}
                                            value={localDangerousClass}
                                            onChange={(event: SelectChangeEvent) => _setDangerousClass(event.target.value) }
                                        >
                                            {['Explosives', 'Flammable Gases', 'Flammable Liquids', 'Flammable Solids', 'Oxidizing', 'Toxic & Infectious', 'Radioactive', 'Corrosives', 'Miscellaneous'].map(_class => (
                                                    <MenuItem key={`${_class}`} value={_class}>{addClassNumber({ dangerousClass: _class })}</MenuItem>
                                            ))}
                                        </Select>
                                        {errors.includes('dangerousClass') && (
                                            <Typography variant='caption' color='error' sx={{ textAlign: 'start' }} component={'div'}>
                                                Please select a class from the list.
                                            </Typography>
                                        )}
                                    </FormControl>
                                    <FormControl variant='outlined' fullWidth sx={{ marginTop: '24px' }}>
                                        <TextField 
                                            error={errors.includes('dangerousUNCode')}
                                            variant='outlined'
                                            label={'UN Code'}
                                            id='dangerous-un-code'
                                            value={localDangerousUNCode}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => { _setDangerousUNCode(event.target.value) }}
                                        />
                                    </FormControl>
                                    {errors.includes('dangerousUNCode') && (
                                        <Typography variant='caption' color='error' sx={{ textAlign: 'start' }} component={'div'}>
                                            Please enter the <b>4 digit numeric code</b>.
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                        )}
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}

export default Product;

function getAirType({ width, height, length, volume, chargeableWeight }) {
    if (volume) {
        return 'volume';
    }
    if (width && height && length) {
        return 'dimensions';
    }
    if (chargeableWeight) {
        return 'chargeable-weight';
    }
    return 'dimensions'; // Default
}
